/**
 * gGlobal Slice for redux
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 07/03/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      07/03/2025    Akhil Soman     Creating new File
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

interface GlobalState {
  loading: boolean;
  notifications: Notification[];
}

const initialState: GlobalState = {
  loading: false,
  notifications: [],
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.push(action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
});

export const { setLoading, addNotification, clearNotifications } = globalSlice.actions;
export default globalSlice.reducer;

// Now you can manage loading state and notifications globally!
// Example usage:
// dispatch(setLoading(true)); // Show spinner
// dispatch(addNotification({ id: '1', message: 'Task completed', type: 'success' }));
// dispatch(clearNotifications()); // Clear all notifications

